<template>
  <section class="success">
    <div class="container screen">
      <div class="row">
        <div class="col-12 col-sm-6">
          <h1>Done!</h1>
          <div class="alert alert-success">
            <div>Your request was successfully submitted.</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Success',
  metaInfo: {
    title: 'Done',
  },
};
</script>

<style scoped></style>
